import { Box } from '@mui/material';
import { useTranslation } from "react-i18next";
import LoaderComp from '../../../../../components/Loader/LoaderComp';
import Btn, { TypeStyle } from '../../../../../components/Button/Btn';
import { BackAndFowardInterface } from '../BackAndFowardComponent';
import { MenuStyles } from '../styles/MenuStyles';

export default function DesloggedButton(props: BackAndFowardInterface) {

    const { t } = useTranslation();

    return (
        <>
            {props.actionForwadOrBackWait ? (
                <Box><LoaderComp/></Box> 
            ) : (
                <Btn
                    text={t("Action.message")}
                    menuProps={{items: [
                        {
                            key: "back",
                            text: props?.backOperation,
                            onClick: props.sendToBack,
                        },
                        {
                            key: "foward",
                            text: props?.forwardOperation,
                            onClick: props.sendToForwardItem,
                        },
                    ],
                    styles: MenuStyles
                    }}
                    style={TypeStyle.startButton}
                />
            )}
        </>
    )
}